import { useCallback, useEffect, useRef } from "react";

export interface ContainerSize {
    width: number;
    height: number;
    left: number;
    top: number;
}

export function useResize() {
    const canvasRef = useRef<HTMLCanvasElement | null>(null);
    const containerRef = useRef<HTMLDivElement | null>(null);
    const containerSizeRef = useRef<ContainerSize>({
        width: 0,
        height: 0,
        left: 0,
        top: 0,
    });

    const resizeCanvas = useCallback(() => {
        if (!canvasRef.current) return;

        const canvas = canvasRef.current;
        const { width, height } = containerSizeRef.current;
        const dpr = devicePixelRatio;

        canvas.width = width * dpr;
        canvas.height = height * dpr;

        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;
        canvas.style.background = "#000000";

        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }, []);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const rect = container.getBoundingClientRect();
        containerSizeRef.current = {
            width: rect.width,
            height: rect.height,
            left: rect.left,
            top: rect.top,
        };
        resizeCanvas();

        const resizeObserver = new ResizeObserver(() => {
            const rect = container.getBoundingClientRect();
            containerSizeRef.current = {
                width: rect.width,
                height: rect.height,
                left: rect.left,
                top: rect.top,
            };
            resizeCanvas();
        });

        resizeObserver.observe(container);
        return () => resizeObserver.disconnect();
    }, [resizeCanvas]);

    return { canvasRef, containerRef, containerSizeRef, resizeCanvas };
}
